import React from "react";

import cx from "classnames";

import RecapSettingsSelector, { type AttendeeValueOptions } from "~/settings/RecapSettingsSelector";
import { Checkbox, Tooltip } from "~/ui";

import styles from "./css/settings.module.css";

export default function RecapSettings({
	value,
	onChange,
	alwaysEmailWhenAttendee,
	onAlwaysEmailWhenAttendeeChange,
	emailDomainList,
	selectorWidth,
	lockToSendToValue,
	lockAlwaysEmailWhenAttendee,
	showNoneInfoBubble = true,
}: {
	value: AttendeeValueOptions;
	onChange: (newValue: AttendeeValueOptions) => void;
	alwaysEmailWhenAttendee: boolean;
	onAlwaysEmailWhenAttendeeChange: () => void;
	emailDomainList: readonly string[];
	lockToSendToValue: boolean;
	lockAlwaysEmailWhenAttendee: boolean;
	selectorWidth?: string;
	showNoneInfoBubble?: boolean;
}) {
	return (
		<>
			<RecapSettingsSelector
				value={value}
				onChange={onChange}
				emailDomainList={emailDomainList}
				width={selectorWidth}
				lockToValue={lockToSendToValue}
			/>

			{showNoneInfoBubble && value === "none" && (
				<div className={styles.infoBubble}>
					Some users have requested AI Notes for all meetings and will receive them regardless of your settings.
				</div>
			)}
			<Tooltip
				content="This setting has been locked by your workspace admin and cannot be changed."
				className={styles.tooltip}
				placement="auto"
				disabled={!lockAlwaysEmailWhenAttendee}
			>
				<div className={cx(styles.checkboxContainer, styles.checkboxContainerWithTooltip)}>
					<Checkbox
						id="alwaysEmailWhenAttendee"
						checked={alwaysEmailWhenAttendee}
						onCheckedChange={onAlwaysEmailWhenAttendeeChange}
						className={styles.checkbox}
						disabled={lockAlwaysEmailWhenAttendee}
					/>
					<label htmlFor="alwaysEmailWhenAttendee" className={styles.label}>
						Always email me AI notes for meetings
					</label>
				</div>
			</Tooltip>
		</>
	);
}
